<template>
  <div
    id="ActionBarComponent"
    class="px-3 pb-3"
  >
    <v-card>
      <v-card-text>
        <span
          id="page-top"
          class="title"
        >
          {{ pageTitle }}
          <div class="subtitle-2">
            {{ pageSubtitle }}
          </div>
        </span>
        <v-spacer />
        <div class="actions">
          <v-btn
            v-for="(action, index) in actions"
            :key="index"
            :color="!!action.color ? action.color : ''"
            :dark="!!action.dark ? action.dark : !action.dark"
            :to="{ name: action.link }"
            :loading="!!action.loading"
            :disabled="!!action.disabled"
            :title="action.title"
            @click="emitAction(action)"
          >
            <span class="d-none d-md-inline">{{ action.text }}</span>
            <v-icon v-if="!!action.icon">
              {{ action.icon }}
            </v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'ActionBarComponent',
  props: {
    pageTitle: {
      type: String,
      default: 'Unnamed page'
    },
    pageSubtitle: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    emitAction (action) {
      if (action.emit) {
        this.$emit(action.emit)
      }
    }
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
@import './resources/sass/agencyTheming';
#ActionBarComponent {
  width: 100%;
  .v-card__text {
    display: flex;
    .actions > .v-btn {
        margin-right: 1rem;
        &.v-btn--disabled {
            background-color: #a2a2a266 !important;
            color: #ffffffbb !important;
        }
    }
  }
}
</style>
